import { jsx } from 'react/jsx-runtime';
import { useResourceDataContextSafe } from '../context/resourceDataContext.js';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { useScrapeRefresh } from '../../hooks/useScrapeRefresh.js';
import { IconMobileSheet24KindBookmark } from '@fabric-app/icons/svg';

const DropdownItemResourceRefreshBookmark = () => {
  const { resource } = useResourceDataContextSafe();
  const { canRefreshScrape, refreshScrape } = useScrapeRefresh(resource);
  if (!canRefreshScrape) {
    return null;
  }
  return /* @__PURE__ */ jsx(DropdownMenu.Item, {
    iconElement: /* @__PURE__ */ jsx(IconMobileSheet24KindBookmark, {}),
    onClick: refreshScrape,
    children: "Refresh bookmark preview"
  });
};

export { DropdownItemResourceRefreshBookmark };
//# sourceMappingURL=DropdownItemResourceRefreshBookmark.js.map
